// extracted by mini-css-extract-plugin
export default {"fixedSocialIcons":"FixedSocialIcons_fixedSocialIcons__7aOec","socialLink":"FixedSocialIcons_socialLink__xbo9b","socialIcon":"FixedSocialIcons_socialIcon__aAG+-"};